<style>
    .customHover:hover{
       cursor:pointer;
        color:#01d89e !important;
    }
</style>
<template>
    <v-app id="enroll">
        <v-content class="white">
            <div id="custom-wrapper">
                <v-container>
                    <v-row align="center" justify="center" class="pa-5 mb-0 pb-0">
                        <v-col cols="12">
                            <v-card class="pattern-bg pa-5 mx-3 text-dark">
                                Bestelling plaatsen
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-alert text :color="b_alert.color" border="left" :type="b_alert.type" dismissible
                                 class="pa-6 mx-5 w-100" id="v-alert" v-if="b_alert.show">{{b_alert.text}}</v-alert>
                    </v-row>
                    <v-row align="center" justify="center" class="mt-1">
                        <v-col cols="12" class="elevation-cs" style="border-radius:15px;">
                            <v-stepper v-model="e1" class="elevation-0">
                                <v-stepper-header :class="{'mx-8': $vuetify.breakpoint.lgAndUp}" class="elevation-0">
                                    <v-stepper-step :complete="e1 > 1" step="1">Gegevens
                                    </v-stepper-step>
                                    <v-divider step="1"></v-divider>
                                    <v-stepper-step :complete="e1 > 2" step="2">Bezorging
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step step="3" :complete="e1 > 3">Controle</v-stepper-step>
                                    <v-divider></v-divider>
                                    <!--<v-stepper-step step="4" :complete="e1 > 4">Betaling</v-stepper-step>-->
                                    <!--<v-divider></v-divider>-->
                                    <v-stepper-step step="4" :complete="e1 > 5" :rules="[v => !!status]">Status
                                        bestelling</v-stepper-step>
                                </v-stepper-header>

                                <v-stepper-items>

                                    <v-stepper-content step="1" :class="{'pt-0 px-0': $vuetify.breakpoint.mdAndDown}">

                                        <v-card color="bg-white-light elevation-0" height="auto">
                                            <div class="mx-5">
                                                <v-container>
<!--                                                    <v-progress-linear color="primary" class="mb-10"-->
<!--                                                                       buffer-value="0" stream></v-progress-linear>-->
                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <!--<h3 class="h-custom">Soort</h3>
                                                        <v-row class="my-fix">
                                                            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                                                                <v-radio-group v-model="businessOrnot" column>
                                                                    <v-radio
                                                                            label="Particulier"
                                                                            color="success"
                                                                            value="particulier"
                                                                    ></v-radio>
                                                                    <v-radio
                                                                            label="Zakelijk"
                                                                            color="success"
                                                                            value="zakelijk"
                                                                    ></v-radio>
                                                                </v-radio-group>
                                                            </v-col>
                                                        </v-row>-->

                                                        <h3 v-if="businessOrnot == 'zakelijk'" class="h-custom">Zakelijk</h3>
                                                        <v-progress-linear v-if="businessOrnot == 'zakelijk'" color="primary" class="mb-10" stream></v-progress-linear>
                                                        <v-row v-if="businessOrnot == 'zakelijk'" class="my-fix">
                                                            <v-col class="my-fix" cols="12" md="6" lg="6" xl="6">
                                                                <v-text-field prepend-icon="mdi-account-box-outline"
                                                                              rounded label="Voornaam" v-model="business.name"
                                                                              :rules="[v => !!v || 'Voornaam is verplicht']"
                                                                              required outlined></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="6" lg="6" xl="6">
                                                                <v-text-field prepend-icon="mdi-clipboard-list-outline"
                                                                              rounded v-model="business.btw_nr"
                                                                              :rules="[v => !!v || 'Btw nummer is verplicht']"
                                                                              label="Btw nummer" required outlined></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="businessOrnot == 'zakelijk'" class="my-fix">
                                                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                                <v-text-field prepend-icon="mdi-email-outline" rounded
                                                                              label="Bedrijfs email" :rules="emailRules"
                                                                              v-model="business.email" required outlined>
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                                <v-text-field type="text" rounded
                                                                              prepend-icon="mdi-phone-in-talk"
                                                                              :rules="phoneRules"
                                                                              v-model="business.phone" label="Bedrijfs telefoonnummer"
                                                                              required outlined>
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="businessOrnot == 'zakelijk'" class="my-fix">
                                                            <v-col cols="12" sm="12" md="12" lg="6" xl="6"
                                                                   class="my-fix">
                                                                <v-text-field prepend-icon=" mdi-chevron-double-right"
                                                                              rounded label="Straatnaam"
                                                                              :rules="[v => !!v || 'Straatnaam is verplicht']"
                                                                              v-model="business.address" required outlined>
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12" lg="3" xl="3"
                                                                   class="my-fix">
                                                                <v-text-field rounded
                                                                              prepend-icon="mdi-chevron-double-right"
                                                                              label="Huisnummer" outlined
                                                                              v-model="business.address_number"
                                                                              :rules="[v => !!v || 'Huisnummer is verplicht']">
                                                                    <!-- v-on:blur="checkAddress" -->
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                                                                <v-text-field rounded
                                                                              prepend-icon="mdi-chevron-double-right"
                                                                              label="Toevoeging" outlined
                                                                              v-model="business.address_extra">
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="businessOrnot == 'zakelijk'" class="my-fix">
                                                            <v-col cols="12" sm="12" md="12" lg="8" xl="8"
                                                                   class="my-fix">
                                                                <v-text-field prepend-icon=" mdi-chevron-double-right"
                                                                              rounded label="Woonplaats"
                                                                              :rules="[v => !!v || 'Woonplaats is verplicht']"
                                                                              required outlined v-model="business.city">
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                                                                <v-text-field prepend-icon="mdi-chevron-double-right"
                                                                              rounded label="Postcode" v-model="business.postal_code"
                                                                              required outlined readonly  :rules="[v => !!v || 'Postcode is verplicht']">
                                                                    <!-- v-on:blur="checkAddress" -->
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>


                                                        <h3 class="h-custom">Persoonlijk</h3>
                                                      <v-progress-linear color="primary" class="mb-10" style="width:100px"
                                                                                                                stream></v-progress-linear>
                                                        <v-row class="my-fix">
                                                            <v-col class="my-fix" cols="12" md="6" lg="6" xl="6">
                                                                <v-text-field prepend-icon="mdi-account-box-outline"
                                                                    rounded label="Voornaam" v-model="order.first_name"
                                                                    :rules="[v => !!v || 'Voornaam is verplicht']"
                                                                    required outlined></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="6" lg="6" xl="6">
                                                                <v-text-field prepend-icon="mdi-account-box-outline"
                                                                    rounded v-model="order.last_name"
                                                                    :rules="[v => !!v || 'Achternaam is verplicht']"
                                                                    label="Achternaam" required outlined></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row class="my-fix">
                                                            <v-col cols="12">
                                                                <v-text-field
                                                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                                    :type="show1 ? 'text' : 'password'"
                                                                    prepend-icon="mdi-lock-outline" rounded
                                                                    v-model="order.password"
                                                                    @click:append="show1 = !show1"
                                                                    :rules="[v => !!v || 'Wachtwoord is verplicht']"
                                                                    label="Wachtwoord" required outlined></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row class="my-fix">
                                                            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                                                <v-menu ref="menu" v-model="menu"
                                                                    :close-on-content-click="false"
                                                                    transition="scale-transition" offset-y
                                                                    min-width="290px">
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-text-field label="Geboortedatum" rounded
                                                                                      readonly
                                                                            :rules="dateRules"
                                                                            prepend-icon="mdi-calendar"
                                                                            v-on="on" v-on:blur="menu=true"
                                                                            v-model="hiddenDate" outlined>
                                                                        </v-text-field>
                                                                    </template>
                                                                    <v-date-picker ref="picker"
                                                                        v-model="order.birthdate"
                                                                                   :hasInputElement="true"
                                                                        :max="new Date().toISOString()"

                                                                                   color="primary darken-1"
                                                                        min="1919-01-01" @change="save"></v-date-picker>
                                                                </v-menu>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="my-fix">
                                                                <v-text-field prepend-icon="mdi-email-outline" rounded
                                                                    label="Email" :rules="emailRules"
                                                                    v-model="order.email" required outlined>
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                                <v-text-field type="text" rounded
                                                                    prepend-icon="mdi-phone-in-talk"
                                                                    :rules="phoneRules"
                                                                    v-model="order.phone" label="Telefoonnummer"
                                                                    required outlined>
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>

                                                        <!-- Splitsing  -->

                                                        <h3 class="h-custom">Woonadres</h3>
                                                      <v-progress-linear color="primary" class="mb-10" style="width:105px"
                                                                         stream></v-progress-linear>
                                                        <v-row class="my-fix">
                                                            <v-col cols="12" sm="12" md="12" lg="6" xl="6"
                                                                   class="my-fix">

                                                                <v-text-field prepend-icon=" mdi-chevron-double-right"
                                                                              rounded label="Straatnaam"
                                                                              :rules="[v => !!v || 'Straatnaam is verplicht']"
                                                                              v-model="order.address" required outlined

                                                                >
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12" lg="3" xl="3"
                                                                class="my-fix">
                                                                <v-text-field rounded
                                                                    prepend-icon="mdi-chevron-double-right"
                                                                    label="Huisnummer" outlined
                                                                    v-model="order.address_number"
                                                                    :rules="[v => !!v || 'Huisnummer is verplicht']"
                                                                              @change="getAddress()"  >
                                                                    <!-- v-on:blur="checkAddress" -->
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                                                                <v-text-field rounded
                                                                    prepend-icon="mdi-chevron-double-right"
                                                                    label="Toevoeging" outlined
                                                                    v-model="order.address_extra">
                                                                </v-text-field>
                                                            </v-col>
<!--                                                          <v-col lg="12" xl="12"-->
<!--                                                                 v-if="addressOptions.length > 0"-->
<!--                                                                 class="font-weight-bold">-->
<!--                                                            <li v-for="option in addressOptions" :key="option" >-->
<!--                                                              <p class="customHover" @click="fillAddressIn(option)">{{option}}</p>-->
<!--                                                            </li>-->
<!--                                                          </v-col>-->
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" sm="12" md="12" lg="8" xl="8"
                                                                class="my-fix">
                                                                <v-text-field prepend-icon=" mdi-chevron-double-right"
                                                                    rounded label="Woonplaats"
                                                                    :rules="[v => !!v || 'Woonplaats is verplicht']"
                                                                    required outlined v-model="order.city"
                                                                              @change="getAddress()">
                                                                </v-text-field>
                                                            </v-col>

                                                            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                                                                <v-text-field prepend-icon="mdi-chevron-double-right"
                                                                              rounded label="Postcode" v-model="order.postal_code"
                                                                              required outlined  :rules="[v => !!v || 'Postcode is verplicht']">
                                                                    <!-- v-on:blur="checkAddress" -->
                                                                </v-text-field>
                                                            </v-col>


                                                        </v-row>

                                                        <!-- Splitsing  -->


                                                        <h3 class="h-custom">Algemene Voorwaarden & Privacy</h3>
                                                      <v-progress-linear color="primary" class="mb-10" style="width:305px"
                                                                         stream></v-progress-linear>
                                                        <v-row>
                                                            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                                                <v-card class="mb-8 mx-1" height="auto" flat>
                                                                    <div class="v-input">
                                                                        <AgvPrivacy class="w-100"
                                                                            @updateBtn="toggleBtn" />
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-form>
                                                </v-container>
                                            </div>
                                        </v-card>

                                        <v-divider></v-divider>
                                        <div class="mx-8 pt-4">
                                            <!-- <v-btn text :to="{'path': '/country'}">Terug</v-btn> -->
                                            <v-btn color="primary" class="float-right"
                                                :disabled="abc == false" @click="e1 = 2;">Volgende</v-btn>
                                        </div>
                                    </v-stepper-content>

                                    <v-stepper-content step="2" class="pt-0">
                                        <v-card color="bg-white-light elevation-0" height="auto">
                                            <div :class="{'mx-5' : $vuetify.breakpoint.mdAndUp}">
                                                <v-container>
                                                    <v-row justify="center">
                                                        <v-expansion-panels accordion mandatory>
<!--                                                            <v-expansion-panel-->
<!--                                                                :class="[activeTab == 1 ? 'bezorgActive' : 'subtitle-2']">-->
<!--                                                                <v-expansion-panel-header @click="activeTab = 1">-->
<!--                                                                    Bezorgen op huidige adres-->
<!--                                                                </v-expansion-panel-header>-->
<!--                                                                <v-expansion-panel-content class="subtitle-2">-->
<!--                                                                    <ul>-->
<!--                                                                        <li class="font-weight-bold text-uppercase">-->
<!--                                                                            {{ order.city}}-->
<!--                                                                        </li>-->
<!--                                                                        <li>-->
<!--                                                                            {{order.address}} {{order.address_number}}-->
<!--                                                                            {{ order.address_extra}}-->
<!--                                                                        </li>-->
<!--                                                                        <li>-->
<!--                                                                            {{order.postal_code}} {{order.city}}-->
<!--                                                                        </li>-->
<!--                                                                    </ul>-->
<!--                                                                </v-expansion-panel-content>-->
<!--                                                            </v-expansion-panel>-->
<!--                                                            <v-expansion-panel-->
<!--                                                                :class="[activeTab == 2 ? 'bezorgActive' : 'subtitle-2']">-->
<!--                                                                <v-expansion-panel-header @click="activeTab = 2">-->
<!--                                                                    Bezorgen op een ander adres-->
<!--                                                                </v-expansion-panel-header>-->
<!--                                                                <v-expansion-panel-content class="subtitle-2">-->
<!--                                                                    <v-form>-->
<!--                                                                        <v-row>-->
<!--                                                                            <v-col cols="12" sm="12" md="12" lg="12"-->
<!--                                                                                xl="12" class="my-fix">-->
<!--                                                                                <v-text-field rounded-->
<!--                                                                                    prepend-icon=" mdi-chevron-double-right"-->
<!--                                                                                    label="Naam" outlined-->
<!--                                                                                    v-model="new_adres.name">-->
<!--                                                                                </v-text-field>-->
<!--                                                                                <v-text-field rounded-->
<!--                                                                                    prepend-icon=" mdi-chevron-double-right"-->
<!--                                                                                    label="Straatnaam" outlined-->
<!--                                                                                    v-model="new_adres.address">-->
<!--                                                                                </v-text-field>-->
<!--                                                                            </v-col>-->
<!--                                                                        </v-row>-->
<!--                                                                        <v-row class="my-fix">-->
<!--                                                                            <v-col cols="12" sm="12" md="12" lg="8"-->
<!--                                                                                xl="8">-->
<!--                                                                                <v-text-field-->
<!--                                                                                    prepend-icon=" mdi-chevron-double-right"-->
<!--                                                                                    rounded label="Woonplaats"-->
<!--                                                                                    :rules="[v => !!v || 'Woonplaats is verplicht']"-->
<!--                                                                                    required outlined-->
<!--                                                                                    v-model="new_adres.city">-->
<!--                                                                                </v-text-field>-->
<!--                                                                            </v-col>-->
<!--                                                                            <v-col cols="12" sm="12" md="12" lg="4"-->
<!--                                                                                xl="4">-->
<!--                                                                                <v-text-field rounded-->
<!--                                                                                    prepend-icon="mdi-chevron-double-right"-->
<!--                                                                                    label="Postcode"-->
<!--                                                                                    v-model="new_adres.postal_code"-->
<!--                                                                                    required outlined>-->
<!--                                                                                </v-text-field>-->
<!--                                                                            </v-col>-->
<!--                                                                        </v-row>-->
<!--                                                                    </v-form>-->
<!--                                                                </v-expansion-panel-content>-->
<!--                                                            </v-expansion-panel>-->

                                                            <v-expansion-panel
                                                                :class="[activeTab === 3 ? 'bezorgActive' : 'subtitle-2']">
                                                                <v-expansion-panel-header @click="activeTab = 3">
                                                                    Ophalen
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="subtitle-2">
                                                                    <ul>
                                                                        <li class="font-weight-bold text-uppercase">
                                                                            {{ order_ophalen.city}}
                                                                        </li>
                                                                        <li>
                                                                            {{order_ophalen.address}}
                                                                        </li>
                                                                        <li>
                                                                            {{order_ophalen.postal_code}}
                                                                        </li>
                                                                    </ul>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </v-row>
                                                </v-container>
                                            </div>
                                        </v-card>
                                        <v-divider class="mt-5"></v-divider>
                                        <v-card-actions>
                                            <v-btn text @click="e1 = 1">Terug</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" class="float-right" @click="e1 = 3;"
                                                :disabled="!valid">Volgende</v-btn>
                                        </v-card-actions>

                                    </v-stepper-content>

                                    <v-stepper-content step="3" class="pt-0">
                                        <v-card class="mb-12" color="bg-white-light elevation-0" height="auto">
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                        <v-card>
                                                            <v-card-title style="border-bottom: 1px solid gainsboro;"
                                                                class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                Bestelling
                                                            </v-card-title>
                                                            <v-card class="mx-auto my-3 elevation-0" v-if="plan">
                                                                <v-img class="productImage" height="200px" contain
                                                                    :src="plan.image">
                                                                </v-img>
                                                                <v-card-title>
                                                                    <h3
                                                                        class="subtitle-1 font-weight-bold text-uppercase">
                                                                        {{plan.name}}
                                                                    </h3>
                                                                </v-card-title>
                                                                <v-card-text>
                                                                    <div>
                                                                        <p class="caption">
                                                                            {{plan.description}}
                                                                        </p>
                                                                    </div>
                                                                </v-card-text>

                                                            </v-card>
                                                        </v-card>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                                        <div>
                                                            <v-card class="subtitle-2 mb-8">
                                                                <v-card-title
                                                                    style="border-bottom: 1px solid gainsboro;"
                                                                    class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Bezorging
                                                                </v-card-title>
                                                                <v-card-text class="subtitle-2">
                                                                    <div class="mt-3">
                                                                        <ul class="pl-0 text-dark"
                                                                            v-if="activeTab == 1">
                                                                            <li>
                                                                                <p
                                                                                    class="text-dark font-weight-bold pb-0 mb-0">
                                                                                    (Dhr. / Mevr.)
                                                                                    <span>{{order.first_name}}
                                                                                        {{order.middle_name}}
                                                                                        {{order.last_name}}</span></p>
                                                                            </li>
                                                                            <v-divider class="my-3"></v-divider>
                                                                            <li class="font-weight-bold text-uppercase">
                                                                                {{ order.city}}
                                                                            </li>
                                                                            <li>
                                                                                {{order.address}}
                                                                                {{order.address_number}}
                                                                                {{ order.address_extra}}
                                                                            </li>
                                                                            <li>
                                                                                {{order.postal_code}}
                                                                            </li>
                                                                        </ul>
                                                                        <ul class="pl-0 text-dark"
                                                                            v-else-if="activeTab == 2">
                                                                            <li>
                                                                                <p
                                                                                    class="text-dark font-weight-bold pb-0 mb-0">
                                                                                    (Dhr. / Mevr.)
                                                                                    <span>{{new_adres.name}}
                                                                                    </span>
                                                                                </p>
                                                                            </li>
                                                                            <v-divider class="my-3"></v-divider>
                                                                            <li class="font-weight-bold text-uppercase">
                                                                                {{ new_adres.city}}
                                                                            </li>
                                                                            <li>
                                                                                {{new_adres.address}}
                                                                                {{new_adres.address_number}}
                                                                                {{ new_adres.address_extra}}
                                                                            </li>
                                                                            <li>
                                                                                {{new_adres.postal_code}}
                                                                            </li>
                                                                        </ul>
                                                                        <ul class="pl-0 text-dark" v-else>
                                                                            <li class="font-weight-bold text-uppercase">
                                                                                {{ order_ophalen.city}}
                                                                            </li>
                                                                            <li>
                                                                                {{order_ophalen.address}}
                                                                            </li>
                                                                            <li>
                                                                                {{order_ophalen.postal_code}}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>

                                                            <v-card v-if="businessOrnot == 'particulier'" flat class="subtitle-2 mb-8">
                                                                <v-card-title
                                                                        style="border-bottom: 1px solid gainsboro;"
                                                                        class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Vul hier uw aantal in
                                                                </v-card-title>
                                                                <v-text-field type="text"
                                                                              :rules="aantalRules"
                                                                              v-model="quantity" placeholder="Aantal"
                                                                              required outlined>
                                                                </v-text-field>

                                                            </v-card>
                                                            <v-card v-else flat class="subtitle-2 mb-8">
                                                                <v-card-title
                                                                        style="border-bottom: 1px solid gainsboro;"
                                                                        class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Vul hier uw aantal in
                                                                </v-card-title>
                                                                <v-text-field type="text"
                                                                              :rules="aantalRules"
                                                                              v-model="quantity" placeholder="Aantal"
                                                                              required outlined>
                                                                </v-text-field>
                                                            </v-card>



                                                            <v-card class="subtitle-2">
                                                                <v-card-title
                                                                    style="border-bottom: 1px solid gainsboro;"
                                                                    class="subtitle-1 font-weight-bold bg-aqua lighten-1 white--text">
                                                                    Prijs
                                                                </v-card-title>
                                                                <v-card-text class="subtitle-2" v-if="plan">
                                                                    <div class="mt-3">
                                                                        <div class="d-flex justify-content-between">
                                                                            <div>Origineel</div>
                                                                            <div class="flex-grow-1"></div>
                                                                            <span :v-model="productTotal">€
                                                                                {{(plan.price * quantity).toFixed(2)}}</span>
                                                                        </div>
                                                                        <div class="d-flex justify-content-between">
                                                                            <div>Bezorging</div>
                                                                            <div class="flex-grow-1"></div>
                                                                            <span :v-model="orderPrice">Gratis</span>
                                                                        </div>
                                                                        <v-divider class="my-2"></v-divider>
                                                                        <div class="d-flex justify-content-between">
                                                                            <div class="font-weight-bold text-dark">
                                                                                Totaalprijs
                                                                            </div>
                                                                            <div class="flex-grow-1"></div>
                                                                            <span :v-model="totalPrice"
                                                                                class="text-dark font-weight-bold">€
                                                                                {{(plan.price * quantity).toFixed(2)}} p/m</span>
                                                                        </div>
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-btn text @click="e1 = 2">Terug</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" class="float-right" :disabled="allowedOrder"
                                                   @click="placeOrderToggle(order); redirect();">Bestellen
                                            </v-btn>
                                        </v-card-actions>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </v-content>
    </v-app>
</template>
<script>
    import {
        mapActions,
        mapState
    } from "vuex";

    import AgvPrivacy from '../../components/AgvPrivacy/AgvPrivacy'

    export default {
        name: 'Enroll',
        components: {
            AgvPrivacy,
        },
        props: {},
        computed: {
            ...mapState({
                plan: state => state.plans.current,
                banks: state => state.order.banks
            }),
            allowedOrder(){
                return !this.quantityAmount.test(this.quantity);
            }
        },
        mounted() {
            this._getPlan(this.$route.params.slug).then(response => {
                console.log(response);
            });
        },
        data: () => ({
            businessOrnot: 'particulier',
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            valid: false,
            status: true,
            quantityAmount: new RegExp('^([1-9]{1}?)[0-9]{0,2}$'),
            emailRules: [
                v => !!v || 'E-mail is verplicht',
                v => /.+@.+\..+/.test(v) || 'Dit emailadres is niet juist',
            ],
            dateRules: [
                v => !!v || 'Datum is verplicht'
            ],
            phoneRules: [
                v => !!v || 'Telefoonnummer is verplicht',
                v => /^[0-9]{9,15}$/.test(v) || 'Dit telefoonnummer is niet juist '
            ],
            aantalRules: [
                v => !!v || 'Aantal is verplicht',
                v => /^([1-9]{1}?)[0-9]{0,2}$/.test(v) || 'Dit is niet een juiste hoeveelheid'
            ],
            lazy: false,
            show1: false,
            e1: 1,
            b_alert: {
                color: '',
                type: '',
                text: '',
                show: false,
            },
            dialog: false,
            date: null,
            menu: false,
            activeTab: 3,
            productTotal: null,
            abc: false,
            orderPrice: null,
            totalPrice: null,
            selectedBank: null,
            quantity: 1,
            hiddenDate: "",
            addressOptions: Array(),
            order: {
                first_name: "",
                middle_name: "",
                last_name: "",
                password: "",
                birthdate: "",
                email: "",
                phone: "",
                address: "",
                address_number: "",
                address_extra: "",
                postal_code: "",
                city: "",
            },
            business: {
                name: "",
                email: "",
                phone: "",
                address: "",
                address_number: "",
                address_extra: "",
                postal_code: "",
                city: "",
                btw_nr: "",
            },
            new_adres: {
                name: "",
                address: "",
                address_number: "",
                address_extra: "",
                postal_code: "",
                city: "",
            },
            order_ophalen: {
                city: "VALENCIA",
                address: "Plaza de los pinazo 5",
                postal_code: "46004",
            },
            errorMessage: null,
        }),
        watch: {
            menu(val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },
        methods: {
            ...mapActions("plans", ["_getPlan"]),
            ...mapActions("customer", ["_preOrder", '_checkAddress']),
            ...mapActions("order", ["_makeOrder"]),
            placeOrderToggle(order) {
                order.consent = this.abc;
                const data = {
                    customer: order,
                    plan_id: this.plan.id,
                    quantity: this.quantity,
                    other_address: this.new_adres
                };

                this.errorMessage = null;
                this._makeOrder(data)
                    .then((data) => {
                      if(data.success){
                        this.$router.push({ name: 'payment', params: { id: data.data.invoice_number }});
                      }else{
                        this.errorMessage = data.error;
                        this.showAlert();
                      }
                    })
                    .catch(() => {
                      this.showAlert();
                    });
            },
          showAlert(){
              this.b_alert.color = "red";
              this.b_alert.type = "error";
              if(this.errorMessage === null){
                this.b_alert.text = 'Er is een fout opgetreden in het systeem, als u de pagina refresht is het probleem waarschijnlijk opgelost';
              }else{
                this.b_alert.text = this.errorMessage;
              }
              this.b_alert.show = true;

              let alert = this.$el.querySelector('#v-alert');
              alert.scrollIntoView();
          },
            save(date) {
                this.order.birthdate = date;
                let dates = date.split('-');
                this.hiddenDate = dates[2] + '-' + dates[1] + '-' + dates[0];
            },
            toggleBtn(val) {
                this.abc = val;
            },
            fillAddressIn(address){
                if(address !== 'Geen adres gevonden'){
                    let split = address.split(' ');
                    const num = split[1].substring(0, split[1].length -1);
                    const regex = new RegExp('[a-z]', 'i');

                    // addres number contains character = 65D
                    if(regex.test(num)) {
                        this.order.address_extra = num.substring(num.length -1, num.length);
                        this.order.address_number = num.substring(0, num.length-1);
                    }else{
                        this.order.address_number = num;
                        this.order.address_extra = '';
                    }
                    this.order.postal_code = split[2];
                    this.order.city = split[3];

                    this.addressOptions = Array();
                }
            },
            getAddress() {
                if (this.order.address !== '' || this.order.address_number !== '') {
                    // Make street name readable
                    let street = this.order.address;
                    if(this.order.address.includes(' ')){
                        street = '';
                        let split = this.order.address.split(' ');
                        for(let i = 0; i < split.length; i++){
                            street = street + split[i] + '-';
                        }
                        street = street.substring(0, street.length - 1);
                    }

                    // Check if array needs to be reset
                    if(this.addressOptions[0] !== 'Geen adres gevonden'){
                        this.addressOptions = Array();
                    }

                    // API call
                    this._checkAddress({
                        street: street,
                        street_nr: this.order.address_number + this.order.address_extra,
                        city: this.order.city
                    }).then((address) => {
                        if(address.length >= 1){
                            this.addressOptions = address;
                        }else{
                            this.addressOptions[0] = "Geen adres gevonden";
                        }
                    });
                }
            },
            loadOptionalAddress(){

            },
            redirect() {
                this.e1 = 3;
                this.b_alert.text = 'U wordt herleid naar de betaalpagina...';
                this.b_alert.color = 'blue';
                this.b_alert.type = 'info';
            },
        }
    }
</script>

<style src="./Enroll.scss" scoped lang="scss"></style>
